import React from 'react'


import parse from 'html-react-parser'
import CanvasJSReact from '../canvasjs-3.7/canvasjs.react';
import {AssayInput} from "../components/AssayRequest";
import util from "../lib/chart_functions";
import * as PropTypes from "prop-types";
import i18n from "i18next";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJSChart.propTypes = {
    options: PropTypes.shape({
        data: PropTypes.any,
        exportEnabled: PropTypes.bool,
        theme: PropTypes.string,
        title: PropTypes.any,
        animationEnabled: PropTypes.bool
    })
};
export default class AssayContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            response: '[]',
            status_code: "200",
            selector_names: ['sex_list', 'type_list', 'organization_list', 'collection_list'],
            headers: ["type_pie", "org_pie", "sex_pie", "age_hist"],
            fields: ["type", "organization", "sex", "age"],
            functions: [util.make_pie_from_json_dict, util.make_pie_from_json_dict, util.make_pie_from_json_dict, util.make_hist_from_json_dict],
            lists: [],
            checkeds: []
        };
    }

    componentDidMount() {
        // GET request using fetch with set headers
        const headers = {'Access-Control-Request-Method': 'GET'}
        fetch(`${process.env.REACT_APP_BACK_END}/assays/?full=true`, {headers})
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}));
    }

    createNewRequest = (input) => {
        const headers = {'Content-Type': 'application/json'}
        const type_input = encodeURIComponent(input.type_input);
        const collection_input = encodeURIComponent(input.collection_input);
        const organization_input = encodeURIComponent(input.organization_input);
        const sex_input = encodeURIComponent(input.sex_input);
        const age_min = encodeURIComponent(input.age[0]);
        const age_max = encodeURIComponent(input.age[1]);
        const age_na = encodeURIComponent(input.age_settings_input.includes('age_na'));
        const age_nb = encodeURIComponent(input.age_settings_input.includes('age_nb'));
        let url = ""
        url += `type=${type_input}&`
        url += `collection=${collection_input}&`
        url += `organization=${organization_input}&`
        // if (sex_input !== ""){
        url += `sex=${sex_input}&`
        // }
        // if (age_min !== ""){
        url += `age_min=${age_min}&`
        // }
        // if (age_max !== ""){
        url += `age_max=${age_max}&`
        // }
        // if (age_na !== ""){
        url += `age_na=${age_na}&`
        // }
        // if (age_nb !== ""){
        url += `age_nb=${age_nb}&`
        fetch(`${process.env.REACT_APP_BACK_END}/assays/?${url}`,
            {headers})
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}));

    }


    render() {
        const {response} = this.state
        const {status_code} = this.state
        let {lists} = this.state
        let {checkeds} = this.state
        const {selector_names} = this.state
        const {headers} = this.state
        const {fields} = this.state
        const {functions} = this.state

        const htmls = []
        let final_table = "<div></div>"
        let L = 0
        let msg = ""
        const ERRORS = ["assays_zero", "patients_zero", "organizations_zero", "collections_zero", "merge_zero"]


        if (status_code === 200 && !ERRORS.includes(response)) {
            const parsed_json = JSON.parse(response)


            const assays = parsed_json["assays"]
            const selectors = parsed_json["selectors"]
            let table_json = parsed_json["table_json"]


            if (typeof assays !== 'undefined') {
                for (const i in fields) {
                    let options = null
                    if (fields[i] !== "age") {
                        options = functions[i](assays[fields[i]], i18n.t(headers[i]), `${fields[i]}_`)
                    } else {
                        options = functions[i](assays[fields[i]], i18n.t(headers[i]), "")
                    }
                    htmls.push(
                        <div className="card-body">
                            <CanvasJSChart options={options}
                            />
                        </div>
                    )
                }
            }

            lists = []
            checkeds = []
            lists['age_settings_list'] = ['age_na', 'age_nb']
            checkeds['age_settings_list'] = [true, true]
            for (const s in selector_names) {
                let s_name = selector_names[s];
                let list = []
                let checked = []
                if (typeof selectors !== 'undefined') {
                    list = selectors[s_name]
                    checked = Array(list.length).fill(true);
                }
                lists[s_name] = list;
                checkeds[s_name] = checked;

            }

            let headerRowHTML = "";
            let allRecordsHTML = "";
            if (typeof table_json !== 'undefined') {
                table_json = JSON.parse(table_json)
                //Get the headers from JSON data
                const theaders = ["filter_organization", "filter_collection","diagnosis", "filter_type", "n"];

                //Prepare html header
                headerRowHTML = '<tr>';
                for (let i = 0; i < theaders.length; i++) {
                    headerRowHTML += '<th>' + i18n.t(theaders[i]) + '</th>';
                }
                headerRowHTML += '</tr>';

                //Prepare all the employee records as HTML
                allRecordsHTML += '<tr>';
                for (let i = 0; i < table_json.length; i++) {
                    //Prepare html row
                    const cur_row = table_json[i]
                    const cur_organization = cur_row['organization']
                    const cur_span = cur_row['n']
                    const cur_collections = cur_row['collection']
                    allRecordsHTML += `<td rowspan="${cur_span}">` + i18n.t("organization_" + cur_organization) + '</td>';
                    for (let j = 0; j < cur_collections.length; j++) {
                        const cur_collection_row = cur_collections[j]
                        const cur_collection = cur_collection_row['collection']
                        const cur_span = cur_collection_row['n']
                        const cur_types = cur_collection_row['type']
                        allRecordsHTML += `<td rowspan="${cur_span}">` + i18n.t("collection_" + cur_collection) + '</td>';
                        allRecordsHTML += `<td rowspan="${cur_span}">` + '</td>';
                        for (let k = 0; k < cur_types.length; k++) {
                            const cur_type_row = cur_types[k]
                            allRecordsHTML += '<td>' + i18n.t("type_" + cur_type_row['type']) + '</td>';
                            allRecordsHTML += '<td>' + cur_type_row['n'] + '</td>';
                            allRecordsHTML += '</tr><tr>';
                        }
                    }

                }
            }

            final_table = '<table id="display_json_data" className="table table-bordered table-striped"><tbody>' +
                headerRowHTML +
                allRecordsHTML +
                '</tbody></table>'

            L = parsed_json['assay_n'];
        } else {
            msg = response
        }
        return (<div className="main-container container">
            <div className="row">
                <div className="col-4">
                    <AssayInput createNewRequest={this.createNewRequest}
                                organization={lists['organization_list']}
                                organization_checked={checkeds['organization_list']}
                                collection={lists['collection_list']} collection_checked={checkeds['collection_list']}
                                type={lists['type_list']} type_checked={checkeds['type_list']}
                                sex={lists['sex_list']} sex_checked={checkeds['sex_list']}
                                age_settings={lists['age_settings_list']}
                                age_settings_checked={checkeds['age_settings_list']}
                                length_objects={L}
                    />
                </div>
                <div className="col-8">
                    {i18n.t(msg)}
                    {parse(final_table)}
                    {htmls}
                </div>
            </div>
        </div>);
    }

}